import { createContext, useContext, useState } from "react";

const FormContext = createContext({
    isFormDirty: false,
    setIsFormDirty: (_: boolean) => { },
});


export const FormContextProvider = ({ children }: any) => {
    const [isFormDirty, setIsFormDirty] = useState(false);

    return (
        <FormContext.Provider value={{ isFormDirty, setIsFormDirty }}>
            {children}
        </FormContext.Provider>
    );
};

export const useFormContext = () => useContext(FormContext);
